import React, { useState } from "react";
import './TeamOfDoctors.css'; 
import Footer from './footer';

const DoctorProfile = ({ doctor, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg lightbox-modal">
        <button onClick={onClose} className="text-right close mb-4 focus:outline-none">
          Close
        </button>
        <h3 className="text-3xl font-semibold text-dark-blue mb-4">{doctor.name}</h3>
        <p className="text-lg text-gray-600 font-italic mb-1">{doctor.specialty}</p>
        <div className="text-lg text-gray-700 leading-relaxed mt-4">
          {doctor.details}
        </div>
      </div>
    </div>
  );
};

const TeamOfDoctors = () => {
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  const doctors = [
    {
      id: 1,
      name: "Dr. Neeraj Kumar",
      specialty: "Internal Medicine Specialist",
      image: "/surgeon.jpg",
      details: (
        <>
          <p>With over 15 years of experience, Dr. Neeraj Kumar is dedicated to providing comprehensive healthcare services to patients at home.</p>
          <p>Known for his commitment to patient care, Dr. Neeraj takes the time to listen to his patients’ concerns, creating a supportive environment that promotes healing and well-being.</p>
          <h4 className="font-semibold mt-2">Areas of Expertise</h4>
          <ul className="list-disc list-inside ml-4">
            <li>Chronic Illness Management</li>
            <li>Preventative Care and Wellness</li>
            <li>Diagnosis and Management of Complex Internal Diseases</li>
            <li>Patient Education and Holistic Care</li>
          </ul>
          <h4 className="font-semibold mt-2">Achievements & Certifications</h4>
          <ul className="list-disc list-inside ml-4">
            <li>Advanced certifications in Internal Medicine</li>
            <li>Regular speaker at national health conferences</li>
            <li>Recipient of multiple awards for patient care excellence</li>
          </ul>
        </>
      ),
    },
    {
      id: 2,
      name: "Dr. Divya Aggarwal",
      specialty: "Homeopathic Physician",
      image: "/doctor4.jpg",
      details: (
        <>
          <p>
            Dr. Divya Aggarwal is among the best homeopathic physicians in Faridabad, with 5+ years of
            overall experience. She is the owner of Shatayu Homeopathy in Faridabad. Her main
            specializations include general medicine, minor surgical treatment, and critical care
            medicine.
          </p>
          <p>
            Dr. Divya has completed M.B.B.S., M.E.M. (USA), and F.F.M. (Mumbai). She is also associated
            with various clinics in Faridabad.
          </p>
          <p>
            With over 5 years of experience, Dr. Divya treats all non-surgical medical conditions,
            including cardiovascular, gastrointestinal, neurological, musculoskeletal, and other
            prominent ones. She is also an expert in treating viral fevers, which are common ailments in
            urban areas.
          </p>
          <p>
            She has equipped her clinic with an advanced laboratory featuring comprehensive blood testing
            facilities. This enables quick diagnoses and treatment for various disorders, making her
            clinic one of the excellent diagnostic centers in Faridabad.
          </p>
          <p>
            Dr. Divya offers treatments like Arthritis Management, Typhoid Fever Treatment, Dengue Fever
            Treatment, Malaria Treatment, Acute Diarrhea Treatment, and Diabetic Ulcer Treatment. She is
            a well-qualified general physician with a strategic approach to managing a wide range of
            medical conditions.
          </p>
          <p>
            Her medical and scientific approach, combined with extensive knowledge of drugs and treatment
            options, ensures accuracy in her treatment protocols. Patients have great trust and faith in
            her diagnosis and treatment, with many successful recoveries from critical conditions like
            dengue to mild viral fevers.
          </p>
          <p>
            Dr. Divya is a wholehearted and welcoming doctor. She provides sufficient consultation time
            and connects well with the medical problems of her patients. Her encouraging attitude gives
            positive vibes and hope to her patients for a fast and safe recovery.
          </p>
          <h4 className="font-semibold mt-2">Achievements</h4>
          <ul className="list-disc list-inside ml-4">
            <li>Member of Medical Committee (WAKO-INDIA)</li>
            <li>
              Certified in Basic Life Support (BLS) and Advanced Cardiovascular Life Support (ACLS)
              treatment protocols
            </li>
            <li>
              Active participation in various conferences like EMERCON and regular health talks
            </li>
          </ul>
          <h4 className="font-semibold mt-2">Memberships</h4>
          <ul className="list-disc list-inside ml-4">
            <li>Member of World Emergency Care Academy</li>
            <li>Member of Medical Committee (WAKO-INDIA)</li>
            <li>Member of Indian Medical Association - Faridabad</li>
            <li>Member of Homeopathic Doctors Association - Faridabad</li>
          </ul>
        </>
      ),
    },
    {
      id: 3,
      name: "Dr. Shatayu Aggarwal",
      specialty: "General Medicine Specialist",
      image: "/doctor5.jpg",
      details: (
        <>
          <p>
            Are you feeling slightly low and offbeat? Are you looking for a general medicine doctor in
            Faridabad? If you are in search of a general physician, then Dr. Shatayu Aggarwal is available
            for consultation and treatment.
          </p>
          <p>
            “I am an Emergency Physician with experience of more than 5+ years in treating and bringing
            smiles on the faces of my patients.”
          </p>
          <p>
            Dr. Shatayu Aggarwal is one of the best general physicians in Faridabad, with over 5 years of
            experience treating general medical issues like viral fever and emergency cases. He is a
            qualified general physician with a Master's in Emergency Medicine.
          </p>
          <p>
            As a general medicine doctor, Dr. Shatayu treats all non-surgical medical conditions,
            including cardiovascular issues like febrile seizures, neurological, and gastrointestinal
            problems. He is an expert in treating viral fevers and typhoid, which are common diseases
            affecting people in cities.
          </p>
          <p>
            Dr. Shatayu has excelled as the best general physician in medical treatment. His diagnostic
            approach towards treating a broad spectrum of medical conditions, combined with extensive
            knowledge of drugs and treatment options, accentuates his accuracy in treatment protocols.
            Patients have trust and faith in his diagnosis and treatment, with many successful recoveries
            from complex dengue treatment to mild seasonal fever.
          </p>
          <p>
            Dr. Shatayu is a warm and friendly doctor. He gives adequate consultation time and relates
            well with the medical issues of his patients. His optimistic attitude gives positive vibes and
            hope to patients for their quick and safe recovery.
          </p>
          <h4 className="font-semibold mt-2">Achievements</h4>
          <ul className="list-disc list-inside ml-4">
            <li>Chairman of Medical Committee (WAKO-INDIA)</li>
            <li>
              Certified in Basic Life Support (BLS) and Advanced Cardiovascular Life Support (ACLS)
              treatment protocols
            </li>
            <li>
              Active participation in various conferences like EMERCON and regular health talks
            </li>
            <li>
              Appreciated for outstanding dedication and service to the nation & fight against
              Coronavirus (COVID-19)
            </li>
          </ul>
          <h4 className="font-semibold mt-2">Memberships</h4>
          <ul className="list-disc list-inside ml-4">
            <li>Member of World Emergency Care Academy</li>
            <li>Member of NIRMAL Foundation</li>
            <li>Member of IMA (Indian Medical Association) Faridabad</li>
          </ul>
        </>
      ),
    },
    
    {
      id: 4,
      name: "Dr. Purshotam Sharma",
      specialty: "General Physician. MBBS",
      image: "/purush1.jpg",
      details: (
        <>
          <p>Dr. Purshotam Sharma is a well-respected general physician known for his patient-centric approach.</p>
          <p>With years of experience, he has helped countless patients recover and maintain their health from the comfort of their homes.</p>
          <h4 className="font-semibold mt-2">Professional Background</h4>
          <ul className="list-disc list-inside ml-4">
            <li>PGIMS Rohtak University Graduate</li>
            <li>Former Chief Medical Officer (CMO) at Holy Family Hospital</li>
            <li>Former Resident Medical Officer (RMO) at Indraprastha Apollo Hospital</li>
          </ul>
          <h4 className="font-semibold mt-2">Areas of Expertise</h4>
          <ul className="list-disc list-inside ml-4">
            <li>Comprehensive General Health Check-ups</li>
            <li>Preventative Care and Health Counseling</li>
            <li>Chronic Illness Management</li>
            <li>Patient-Centered Primary Care</li>
          </ul>
        </>
      ),
    },
  ];

  const handleOpenLightbox = (doctor) => {
    setSelectedDoctor(doctor);
  };

  const handleCloseLightbox = () => {
    setSelectedDoctor(null);
  };

  return (
    <>
      <section className="tod team-page py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-dark-blue mb-12">Meet Our Dedicated Healthcare Professionals</h1>

          <div className="flex flex-col md:flex-row justify-center items-start gap-12">
            {doctors.map((doctor) => (
              <div key={doctor.id} className="doctor-profile w-full md:w-1/2 text-left">
                <img src={process.env.PUBLIC_URL + doctor.image} alt={doctor.name} className="w-full rounded-lg shadow-md mb-4" />
                <h3 className="text-3xl font-semibold text-dark-blue mb-2">{doctor.name}</h3>
                <p className="text-lg text-gray-600 font-italic mb-1">{doctor.specialty}</p>
                <button
                  className="text-lg readmore leading-relaxed focus:outline-none"
                  onClick={() => handleOpenLightbox(doctor)}
                >
                  View Details
                </button>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <h4 className="text-2xl font-semibold text-dark-blue mb-4">Additional Doctors</h4>
            <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
              Our team is growing! We are continuously adding more skilled professionals to ensure that all your healthcare needs are met.
            </p>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      <DoctorProfile doctor={selectedDoctor} isOpen={!!selectedDoctor} onClose={handleCloseLightbox} />
      <Footer />
    </>
  );
};

export default TeamOfDoctors;
